import { translate } from 'services/i18nService';


export function normalizeInformation(information, performerName) {
  if (information?.includes('gamification')) {
    return translate(information, { 0: performerName });
  }

  return information;
}

export function capitalizeDescription(information, name, performerName) {
  if (information.includes('%%username%%')) {
    return information.replace('%%username%%', name);
  }

  if (information.includes('{0}')) {
    return information.replace('{0}', performerName);
  }

  return information;
}

export function compareAchievements(firstAchievement, secondAchievement) {
  return firstAchievement.order - secondAchievement.order;
}

export function compareProgress(firstAchievement, secondAchievement) {
  const compare = secondAchievement.progress - firstAchievement.progress;
  if (compare === 0) {
    return compareAchievements(firstAchievement, secondAchievement);
  }

  return compare;
}

export function normalizeAchievementsStrings(name, type) {
  if (name?.includes(' ')) {
    const formatName = name.toLowerCase().replaceAll(' ', '');

    return `gamification.trophies.trophycard.${formatName}.${type}`;
  }

  return `gamification.trophies.trophycard.${name?.toLowerCase()}.${type}`;
}

export function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
